import { ComponentInstanceService } from '@diagram/services/ComponentInstanceService';
import { ConnectionService } from '@diagram/services/ConnectionService';
import { LabelService } from '@diagram/services/LabelService';

import { Diagram, DiagramComponentInstance, DiagramPosition } from 'models';

export type DiagramFootprint = {
    x: number;
    y: number;
    colSpan: number;
    rowSpan: number;
};

const DiagramHelpers = {
    footprint: (
        componentInstance: DiagramComponentInstance,
        delta: DiagramPosition = { x: 0, y: 0 },
    ): DiagramFootprint => {
        const { position, colSpan, rowSpan } = componentInstance;

        return {
            x: position.x + delta.x,
            y: position.y + delta.y,
            colSpan,
            rowSpan,
        };
    },

    replaceIdsWithLabels: (text: string): string => {
        let message = text;

        const componentInstancePattern = /component-[A-Za-z0-9]+/g;
        const connectionPattern = /connection-[A-Za-z0-9]+/g;

        const componentMatches = message.match(componentInstancePattern) || [];
        const connectionMatches = message.match(connectionPattern) || [];

        componentMatches.forEach((id) => {
            const componentInstance = ComponentInstanceService.getByIdSafe(id);

            if (componentInstance) {
                const label = LabelService.getComponentLabel(componentInstance);
                message = message.replace(new RegExp(id, 'g'), `"${label}"`);
            }
        });

        connectionMatches.forEach((id) => {
            const connection = ConnectionService.getById(id);

            if (connection) {
                const label = LabelService.getConnectionLabel(connection);
                message = message.replace(new RegExp(id, 'g'), `"${label}"`);
            }
        });

        return message;
    },

    connectors: (_diagram: Diagram) => {
        const diagram = JSON.parse(JSON.stringify(_diagram)) as Diagram;
        const connectors: any[] = [];

        const { componentInstances, connections } = diagram;

        Object.values(componentInstances).forEach((componentInstance, index) => {
            if (componentInstance.componentType === 'connector') {
                Object.values(connections).forEach((connection) => {
                    let linked = null;
                    let index = null;

                    if (connection.from.componentInstanceId === componentInstance.id && connection.to.port !== null) {
                        linked = componentInstances[connection.to.componentInstanceId];
                        index = connection.to.port;
                    }

                    if (connection.to.componentInstanceId === componentInstance.id && connection.from.port !== null) {
                        linked = componentInstances[connection.from.componentInstanceId];
                        index = connection.from.port;
                    }

                    if (linked && index !== null) {
                        const port = linked.specifications.electrical.ports[index];
                        port.label = componentInstance.label || linked.label || linked.designator;

                        connectors.push(port);
                    }
                });
            }
        });

        return connectors;
    },
};

export { DiagramHelpers };
